import { postPointOfInterstsExportSearchResultsOverride, Station, TableDto } from "api"
import { InstallationStationsSearchRequest } from "api/api/APIOverride/PazInterfaces"
import { trackEventName } from "reusable/ChargeGTM"

export const onPrint = async (list: Station[]) => {
    const { generatePDF } = await import("lib/generatePDF")
    const array = list.map((object) => Object.values(object)) || []
    const printArray: TableDto = {
        Header: { Columns: ["שם התחנה", "כתובת", " מאפייני תחנה "] },
        Rows: array.map((el) => ({
            Columns: [
                el[3],
                el[4],
                el[16].map((item: any) => item?.name).join(" ,"),
            ],
        })),
        Footer: { Columns: [] },
        SubTitle: "",
        Title: "",
    }
    generatePDF([printArray])
}

export const onDownload = async (
    selectedCityName?: string,
    searchValue?: string,
    filters?: any
) => {
    const reqBody: InstallationStationsSearchRequest = {
        SearchTerm: selectedCityName || searchValue || "",
        Attributes: [],
        InstallationProvider: "Orpak",
        MetaData: filters?.map((filter: any) => filter.id) || [],
    }
    const response = await postPointOfInterstsExportSearchResultsOverride("", reqBody)
    if (response.data) {
        const FileSaver = (await import("file-saver")).default
        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
        const fileName = selectedCityName || searchValue
        FileSaver.saveAs(blob, `${fileName ? fileName + "_" : ""}stations.xlsx`)
        trackEventName("Map_download")
    }
}
